<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Task Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="New Test Task">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add test task'">
      <template #gated-content>
        <test-task-form :test_process="test_process" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TestTaskForm from "@/components/lab/testtask/TestTaskForm";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testTaskNotifications } from "@/shared/notifications";

const TestTaskRepository = LabRepositoryFactory.get("testTask");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TestTaskAdd",
  components: {
    BasicHeading,
    TestTaskForm,
    PermissionAlertGate,
    HeaderButtonGroup,
  },
  data() {
    return {
      loading: true,
      test_process_id: this.$route.params.test_process_id || null,
      test_process: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: `/test-processes/${this.test_process_id}`,
            title: "Test Task list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      const { name, description, relations } = form_data;
      const payload = {
        name,
        description,
        relations,
        test_process_id: this.test_process_id,
      };

      try {
        const { data } = await TestTaskRepository.create(payload);

        this.addSuccess();

        this.$router.push(`/test-tasks/${data.id}`);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Task creation Failed.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.test_process = await getModel({
      model_type: "test_process",
      id: this.test_process_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: testTaskNotifications,
};
</script>
